import { isNumber } from "lodash";

export const getWaitTime = (message) => {
  const waitTime = message.wait_time;
  return isNumber(waitTime) && waitTime > 0
    ? waitTime
    : 1000;
};

export const calculateWaitTime = (waitTime, postedAt) => {
  const sincePostedMs = new Date() - postedAt;
  return Math.max(0, waitTime - sincePostedMs);
};

export const transformMessages = (messages, options) => {
  return messages.map((message, idx) => {
    const waitTime = getWaitTime(message);
    message.wait_time =
      idx === 0
        ? calculateWaitTime(waitTime, options.userMessagePostedAt)
        : waitTime;

    return message;
  });
};
